var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagIt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M32 16C32 9.12 27.658 3.256 21.565.995v30.01C27.658 28.745 32 22.879 32 16"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6DA544",
  d: "M0 16c0 6.88 4.342 12.744 10.435 15.005V.995C4.342 3.255 0 9.121 0 16"
})));
export default SvgFlagIt;